export const isNumber = (value: string): boolean => {
  if (!value) return false;
  if (typeof value !== 'string') return false;
  return !isNaN(Number(value)) && !isNaN(parseFloat(value));
};
